import { format, isValid } from 'date-fns';
// TODO: Move under lib
export const convertAggregatedTicketSearchParamsToBackend = (params) => {
    const backendParams = {};
    for (const key in params) {
        if (params[key] !== null && params[key] !== undefined) {
            if (isValid(params[key])) {
                backendParams[key] = format(params[key], 'yyyy-MM-dd');
            }
            else {
                backendParams[key] = params[key];
            }
        }
    }
    return backendParams;
};
export const getSumMoney = (tickets, key) => tickets.map((ticket) => ticket[key]);
export const aggregatedSalesByPropName = (tickets, propName) => {
    const aggregatedSales = tickets.reduce((sales, ticket) => {
        const field = ticket[propName];
        const fieldValue = Array.isArray(field) ? field[0] : field;
        if (fieldValue === undefined)
            return sales;
        sales[fieldValue] = {
            amount: (sales[fieldValue]?.amount || 0) + ticket.sumSales.amount,
            currency: 'EUR',
        };
        return sales;
    }, {});
    const sortedByAmount = Object.entries(aggregatedSales).sort((sortA, sortB) => sortB[1].amount - sortA[1].amount);
    if (sortedByAmount.length <= 4)
        return sortedByAmount;
    const firstFour = sortedByAmount.slice(0, 4);
    const restAggregated = sortedByAmount.slice(4, -1).reduce((acc, [, value]) => {
        acc[1] = {
            amount: acc[1]?.amount + value.amount,
            currency: 'EUR',
        };
        return acc;
    }, ['Sonstige', { amount: 0, currency: 'EUR' }]);
    return [...firstFour, restAggregated];
};
